import axios from 'axios';

const HEALTH_ENDPOINT = `${process.env.VUE_APP_API_URL}/api/v1/health`;
const PROBE_TIMEOUT = 8000;
const POLL_INTERVAL = 15000;
const HEARTBEAT_INTERVAL = 60000;

// Istanza dedicata: usa quella globale significherebbe rientrare negli
// interceptor e innescare un ciclo di controlli su ogni controllo fallito.
const probe = () => axios.get(HEALTH_ENDPOINT, { timeout: PROBE_TIMEOUT });

let pollTimer = null;
let heartbeatTimer = null;

const reasonFor = error => {
  const status = error && error.response ? error.response.status : null;
  if (status === 503) {
    return 'maintenance';
  }
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    return 'offline';
  }
  return 'unreachable';
};

const state = {
  unavailable: false,
  reason: null,
  checking: false,
};

const actions = {
  // Una singola chiamata fallita non basta a dichiarare il backend giu':
  // puo' essere una richiesta annullata o un blip di rete. Si verifica
  // sempre con la sonda /health prima di coprire l'interfaccia.
  async check({ commit, dispatch, state }) {
    if (state.checking) {
      return state.unavailable;
    }

    commit('checkStart');
    try {
      await probe();
      commit('backendAvailable');
      dispatch('stopPolling');
      return false;
    } catch (error) {
      commit('backendUnavailable', reasonFor(error));
      dispatch('startPolling');
      return true;
    } finally {
      commit('checkEnd');
    }
  },

  // Il 503 arriva direttamente dalla manutenzione Laravel: non serve confermarlo.
  reportMaintenance({ commit, dispatch }) {
    commit('backendUnavailable', 'maintenance');
    dispatch('startPolling');
  },

  // Una risposta valida chiude subito la pagina di manutenzione.
  reportReachable({ commit, dispatch, state }) {
    if (!state.unavailable) {
      return;
    }
    commit('backendAvailable');
    dispatch('stopPolling');
  },

  startPolling({ dispatch }) {
    if (pollTimer) {
      return;
    }
    pollTimer = setInterval(() => {
      dispatch('check');
    }, POLL_INTERVAL);
  },

  stopPolling() {
    if (pollTimer) {
      clearInterval(pollTimer);
      pollTimer = null;
    }
  },

  // Senza battito la manutenzione si scoprirebbe solo alla prima azione
  // dell'utente: chi lascia una schermata aperta continuerebbe a vedere
  // dati validi mentre il backend e' gia' giu'.
  startHeartbeat({ dispatch, state }) {
    if (heartbeatTimer) {
      return;
    }
    heartbeatTimer = setInterval(() => {
      if (state.unavailable) {
        return;
      }
      if (typeof document !== 'undefined' && document.hidden) {
        return;
      }
      dispatch('check');
    }, HEARTBEAT_INTERVAL);
  },

  stopHeartbeat() {
    if (heartbeatTimer) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  },
};

const mutations = {
  checkStart(state) {
    state.checking = true;
  },

  checkEnd(state) {
    state.checking = false;
  },

  backendUnavailable(state, reason) {
    state.unavailable = true;
    state.reason = reason;
  },

  backendAvailable(state) {
    state.unavailable = false;
    state.reason = null;
  },
};

export const system = {
  namespaced: true,
  state,
  actions,
  mutations,
};
